import { Leaderboard } from 'leaderboards'
import { DonorRoll } from 'donorRoll'
import { Affiliation } from 'affiliation'
import { Dashboard } from 'dashboards'
import { Ambassador } from 'ambassador'
import { Viewchallenge } from 'viewchallenge'
import React, { useEffect } from 'react';
import { getSettings } from 'api/sagas'
import { useSelector, useDispatch } from 'react-redux'
import { DataMap } from 'mapVisualizer'

export interface AppProps {
    controlId: number;
    getApiPollingTimeInterval: () => void;
}

const App: React.FC<AppProps> = ({ controlId }) => {
    const dispatch: any = useDispatch();
    const scoreboardTypeId = useSelector((state: RootState) => state.config.scoreboardTypeId);
    useEffect(() => {
        dispatch(getSettings(controlId));
    }, [dispatch, controlId]);
    return (
        <div data-scoreboardId={scoreboardTypeId} data-controlId={controlId}>
            {scoreboardTypeId === 10 && <Ambassador />}
            {scoreboardTypeId === 7 && <Affiliation />}
            {scoreboardTypeId === 6 && <DonorRoll />}
            {scoreboardTypeId === 5 && <Leaderboard />}
            {scoreboardTypeId === 9 && <Leaderboard />}
            {scoreboardTypeId === 13 && <Leaderboard />}
            {scoreboardTypeId === 8 && <Dashboard />}
            {scoreboardTypeId === 1 && <DataMap />}
            {scoreboardTypeId === 2 && <DataMap />}
            {scoreboardTypeId === 3 && <DataMap />}
            {scoreboardTypeId === 4 && <DataMap />}
            {scoreboardTypeId === 11 && <Viewchallenge />}
        </div>
    );
};

export default App;

